import axios from 'axios'
const prod = process.env.NODE_ENV === 'production';

class Pagination {
  constructor(el) {
    this.el = el
    this.window = window
    this.setVars()
    this.bindEvents()
  }

  setVars() {
    this.nextButton = this.el.querySelector('button')
    this.nextPageUrl = this.nextButton.getAttribute('data-href')
    this.resultsSelector = '[data-pagination-results] article'
    this.resultsContainer = document.querySelector('[data-pagination-results]')
    this.ariaLive = this.el.querySelector('[data-pagination-aria-live]')
    this.autoLoad = this.nextButton.hasAttribute('data-auto-load');
    this.autoFocus = true;

    if (this.nextPageUrl) this.initiallyEnableButton()
  }

  initiallyEnableButton() {
    this.el.classList.remove('hidden')
    this.nextButton.addEventListener('click', this.handleLoadMore)
    this.prepareButton()
  }

  prepareButton() {
    this.nextPageUrl ? this.enableButton() : this.removeButton()
  }

  enableButton() {
    this.nextButton.classList.remove('opacity-25')
    this.nextButton.removeAttribute('disabled')
    this.nextButton.textContent = 'Load more'
  }

  disableButton() {
    this.nextButton.classList.add('opacity-25')
    this.nextButton.setAttribute('disabled', 'disabled')
    this.nextButton.textContent = 'Loading'
  }

  removeButton() {
    this.el.removeChild(this.nextButton)
  }

  handleLoadMore = () => {
    this.disableButton()
    this.ariaLive.textContent = 'Loading content.'

    axios
      .get(this.nextPageUrl)
      .then(({ data }) => {
        this.appendResults(data)
      })
      .catch(error => {
          if(prod) {
              window.location = this.nextPageUrl
          } else {
              console.log(error);
          }
      })
      .then(() => {
        this.prepareButton()
      })
  }


    isElementInView() {
        const rect = this.nextButton.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        return (elemTop >= 0) && (elemBottom <= window.innerHeight);
    }


    bindEvents() {
      if(this.autoLoad) {
        this.window.addEventListener('scroll', this.handleAutoLoad.bind(this))
      }
    }

  handleAutoLoad() {
    this.autoFocus = false;
    if(this.isElementInView()) {
        this.nextButton.click();
    }
  }


    appendResults = body => {
    // Get nodelist of new results
    const tempBody = document.createElement('div')
    tempBody.innerHTML = body
    const moreResults = [...tempBody.querySelectorAll(this.resultsSelector)]

    // Get next page url, if exists
    const nextButton = tempBody.querySelector('[data-load-more]')
    this.nextPageUrl = nextButton.getAttribute('data-href')

    // Append new results
    moreResults.forEach(result => this.resultsContainer.appendChild(result))

    // Move focus to first new result
    if(this.autoFocus) {
        const firstResult = moreResults[0].querySelector('a')
        firstResult.focus()
    }

    // Update screenreader
    this.ariaLive.textContent = 'Content loaded.'
  }


}

export default Pagination
